<template>
    <div>

      <b-modal id="modal-matriz" ref="my-modal-matriz" :ok-title="btnGrabarMatriz" cancel-title="Cerrar" centered
               size="lg" :title="titleModalMatriz" @show="resetModalMatriz" @hidden="resetModalMatriz"
               @ok="handleOkMatriz">

        <validation-observer ref="simpleRules">
          <b-form>

            <b-tabs>
              <b-tab active>
                <template #title>
                  <feather-icon icon="ArchiveIcon" />
                  <span>General</span>
                </template>

                <b-row>

                  <b-col md="6">
                    <b-form-group>
                      <label>Categoria</label>
                      <validation-provider #default="{ errors }" rules="required" name="Categoria">
                        <b-form-select v-model="selectedCategoriaGuardar"
                                       :state="errors.length > 0 ? false : null"
                                       :options="optionsCategoriaGuardar"
                                       v-on:change="mostrarSubCategoria()" />
                        <small class="text-danger" v-if="errors[0]">El campo Categoria es
                          obligatorio</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group>
                      <label>Sub Categoria</label>
                      <validation-provider #default="{ errors }" rules="required"
                                           name="Sub Categoria">
                        <b-form-select v-model="selectedSubCategoriaGuardar"
                                       :state="errors.length > 0 ? false : null"
                                       :options="optionsSubCategoriaGuardar" v-on:change="obtenerMatriz()" />
                        <small class="text-danger" v-if="errors[0]">El campo Sub Categoria es
                          obligatorio</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                      <label>Reportado por</label>
                      <validation-provider #default="{ errors }" rules="required"
                                           name="Reportado por">
                        <vue-autosuggest ref="autocomplete"
                                         :suggestions="filteredOptionsTrabajadorReportado"
                                         v-model="queryTrabajadorReportado" :limit="10"
                                         :state="errors.length > 0 ? false : null"
                                         :input-props="{ id: 'autosuggest__input', class: 'form-control', placeholder: 'Buscar por' }"
                                         :get-suggestion-value="getTrabajadoresValue" @input="onInputChange">

                          <template slot-scope="{suggestion}">
                                                      <span class="my-suggestion-item">{{ suggestion.item.numero_documento
                                                        }}
                                                          | {{
                                                          suggestion.item.nombres
                                                        }} {{ suggestion.item.apellido_paterno
                                                        }} {{
                                                          suggestion.item.apellido_materno
                                                        }} </span>
                          </template>

                        </vue-autosuggest>
                        <small class="text-danger"
                               v-if="errors[0] && mensajeErrorReportadoPor === ''">El campo Reportado
                          por es
                          obligatorio</small>

                        <small class="text-danger"
                               v-if="errors[0] && mensajeErrorReportadoPor !== ''">{{
                            mensajeErrorReportadoPor
                          }}</small>
                      </validation-provider>

                  </b-col>

                  <b-col md="6">
                    <b-form-group>
                      <label>Empresa</label>
                      <validation-provider #default="{ errors }" rules="required" name="Empresa">
                        <b-form-select v-model="selectedEmpresaGuardar"
                                       :state="errors.length > 0 ? false : null"
                                       :options="optionsEmpresaGuardar" v-on:change="mostrarCultivo()" />
                        <small class="text-danger" v-if="errors[0]">El campo Empresa es
                          obligatorio</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group>
                      <label>Cultivo ó Departamento</label>
                      <validation-provider #default="{ errors }" rules="required" name="Cultivo">
                        <b-form-select v-model="selectedCultivoGuardar"
                                       :state="errors.length > 0 ? false : null"
                                       :options="optionsCultivoGuardar" v-on:change="mostrarFundo()" />
                        <small class="text-danger" v-if="errors[0]">El campo Cultivo es
                          obligatorio</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group>
                      <label>Fundo ó Área</label>
                      <validation-provider #default="{ errors }" rules="required" name="Fundo">
                        <b-form-select v-model="selectedFundoGuardar"
                                       :state="errors.length > 0 ? false : null" :options="optionsFundoGuardar"
                                       v-on:change="mostrarLugar()" />
                        <small class="text-danger" v-if="errors[0]">El campo Fundo es
                          obligatorio</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="6">
                    <b-form-group>
                      <label>Lugar ó Sección</label>
                      <validation-provider #default="{ errors }" rules="required" name="Lugar">
                        <b-form-select v-model="selectedLugarGuardar"
                                       :state="errors.length > 0 ? false : null" :options="optionsLugarGuardar"
                                       v-on:change="mostrarEtapa()" />
                        <small class="text-danger" v-if="errors[0]">El campo Lugar es
                          obligatorio</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="6" v-if="this.selectedLugarGuardar === 'CAMPO'">
                    <b-form-group>
                      <label>Etapa</label>
                      <b-form-select v-model="selectedEtapaGuardar" :options="optionsEtapaGuardar"
                                     v-on:change="mostrarCampo()" />
                    </b-form-group>
                  </b-col>

                  <b-col md="6" v-if="this.selectedLugarGuardar === 'CAMPO'">
                    <b-form-group>
                      <label>Campo</label>
                      <b-form-select v-model="selectedCampoGuardar" :options="optionsCampoGuardar" />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group>
                      <label>Descripción</label>
                      <validation-provider #default="{ errors }" rules="required" name="Descripción">
                        <b-form-input v-model="descripcion"
                                      :state="errors.length > 0 ? false : null" placeholder="Descripción" />
                        <small class="text-danger" v-if="errors[0]">El campo Descripción es
                          obligatorio</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group>
                      <label>Observación</label>
                      <b-form-input v-model="observacion" placeholder="Observación" />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group>
                      <label>Evidencia</label>
                      <b-form-file v-model="filesEv"
                                   accept=".jpg, .jpeg, .png, .mp3, .wav, .3gp, .mov, .avi, .mp4, .flv, .docx, .pdf, .xlsx, .pptx"
                                   placeholder="Ningún archivo elegido" browse-text="Archivos" multiple />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group>
                      <label>Descargo</label>
                      <b-form-file v-model="filesDe"
                                   accept=".jpg, .jpeg, .png, .mp3, .wav, .3gp, .mov, .avi, .mp4, .flv, .docx, .pdf, .xlsx, .pptx"
                                   placeholder="Ningún archivo elegido" browse-text="Archivos" multiple />
                    </b-form-group>
                  </b-col>

                </b-row>
              </b-tab>

              <b-tab v-if="this.matrizencontrada[0] !== undefined">
                <template #title>
                  <feather-icon icon="UsersIcon" />
                  <span>Involucrados</span>
                </template>

                <b-row>
                  <b-col md="12">
                    <b-form-group>
                      <label>Agregar Involucrado</label>
                      <vue-autosuggest ref="autocomplete" :suggestions="filteredOptionsInvolucrado"
                                       v-model="queryInvolucrado" :limit="10"
                                       :input-props="{ id: 'autosuggest__input', class: 'form-control', placeholder: 'Buscar por' }"
                                       :get-suggestion-value="getInvolucradosValue"
                                       @input="onInputChangeInvolucrado">

                        <template slot-scope="{suggestion}">
                                                  <span class="my-suggestion-item">{{ suggestion.item.numero_documento
                                                    }}
                                                      | {{
                                                      suggestion.item.nombres
                                                    }} {{ suggestion.item.apellido_paterno
                                                    }} {{
                                                      suggestion.item.apellido_materno
                                                    }} </span>
                        </template>

                      </vue-autosuggest>
                      <small class="text-success"
                             v-if="selectedInvolucradoGuardar.length !== 0 && mensajeErrorInvolucrados === ''">Involucrado
                        Agregado Correctamente</small>
                      <small class="text-danger" v-if="mensajeErrorInvolucrados !== ''">{{
                          mensajeErrorInvolucrados
                        }}</small>

                    </b-form-group>
                  </b-col>

                  <b-col md="8" v-if="this.involucrados.length !== 0">

                    <label>Lista de Involucrados</label>
                    <b-list-group>
                      <template v-for="item in this.involucrados">
                        <b-list-group-item class="d-flex justify-content-between align-items-center"
                                           v-bind:class="[involucradoSeleccionado === item.dni_involucrado ? 'active' : '']">
                                                  <span class="mr-1" style="cursor: pointer;"
                                                        v-on:click="eliminarInvolucrado(item.dni_involucrado)">
                                                      <feather-icon icon="TrashIcon" size="16" />
                                                  </span>
                          <span href="#" style="cursor: pointer;"
                                v-on:click="mostrarDetalleFechas(item.dni_involucrado)">{{
                              item.nombre_involucrado
                            }}</span>

                          <b-badge variant="warning" pill class="badge-round">
                            {{ item.descripcion_tipo_sancion }}
                          </b-badge>



                        </b-list-group-item>
                      </template>
                    </b-list-group>


                  </b-col>

                  <b-col md="4"
                         v-if="this.involucradoSeleccionado.length !== 0 && this.involucradoSeleccionadoCantFechas !== 0">
                    <label>Fechas de Involucrados</label>
                    <template v-for="item in this.fechasinvolucrados">
                      <b-input-group class="mb-1"
                                     v-if="item.dni_involucrado === involucradoSeleccionado">
                        <b-form-input type="text" placeholder="YYYY-MM-DD" autocomplete="off"
                                      show-decade-nav v-model.lazy="item.fecha_sancion" />
                        <b-input-group-append>
                          <b-form-datepicker show-decade-nav v-model.lazy="item.fecha_sancion"
                                             button-only right locale="es-ES" size="sm" />
                        </b-input-group-append>
                      </b-input-group>
                    </template>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>

          </b-form>
        </validation-observer>

      </b-modal>

      <div class="row">
        <div class="col-md-12 co-12">
          <b-card title="Búsqueda">

            <b-row>


              <b-col md="6" xl="4">

                <label for="txtFechaDesde">Desde</label>
                <b-input-group class="mb-1">
                  <b-form-input id="txtFechaDesde" v-model="txtFechaDesde" type="text"
                                placeholder="YYYY-MM-DD" autocomplete="off" show-decade-nav />
                  <b-input-group-append>
                    <b-form-datepicker v-model="txtFechaDesde" show-decade-nav button-only right
                                       locale="es-ES" aria-controls="txtFechaDesde" size="sm" />
                  </b-input-group-append>
                </b-input-group>

              </b-col>


              <b-col md="6" xl="4">
                <label for="txtFechaHasta">Hasta</label>
                <b-input-group class="mb-1">
                  <b-form-input id="txtFechaHasta" v-model="txtFechaHasta" type="text"
                                placeholder="YYYY-MM-DD" autocomplete="off" show-decade-nav />
                  <b-input-group-append>
                    <b-form-datepicker v-model="txtFechaHasta" show-decade-nav button-only right
                                       locale="es-ES" aria-controls="txtFechaHasta" size="sm" />
                  </b-input-group-append>
                </b-input-group>
              </b-col>


              <b-col md="6" xl="4">
                <b-form-group label="Empresa" label-for="empresa">
                  <b-form-select v-model="selectedEmpresa" :options="optionsEmpresa" v-on:change="mostrarCultivoFiltro()" />
                </b-form-group>
              </b-col>

              <b-col md="6" xl="4">
                <b-form-group label="Cultivo" label-for="Cultivo">
                  <b-form-select v-model="selectedCultivo" :options="optionsCultivo" v-on:change="mostrarFundoFiltro()" />
                </b-form-group>
              </b-col>

              <b-col md="6" xl="4">
                <b-form-group label="Fundo" label-for="Fundo">
                  <b-form-select v-model="selectedFundo" :options="optionsFundo" v-on:change="mostrarLugarFiltro()"  />
                </b-form-group>
              </b-col>

              <b-col md="6" xl="4">
                <b-form-group label="Lugar" label-for="Lugar">
                  <b-form-select v-model="selectedLugar" :options="optionsLugar" />
                </b-form-group>
              </b-col>

              <b-col md="6" xl="4">
                <b-form-group label="Categoria" label-for="categoria">
                  <b-form-select v-model="selectedCategoria" :options="optionsCategoria" />
                </b-form-group>
              </b-col>

              <b-col md="6" xl="4">
                <b-form-group label="Estado" label-for="estado">
                  <b-form-select v-model="selectedEstado" :options="optionsEstado" />
                </b-form-group>
              </b-col>

              <!-- block -->
              <b-col md="6" xl="4">
                <div class="demo-inline-spacing">
                  <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                            v-on:click="obtenerSanciones()">
                    Filtrar
                  </b-button>
                </div>
              </b-col>


            </b-row>

          </b-card>
        </div>


        <div class="col-md-12 co-12">

          <b-card title="Lista de Sanciones">

            <b-row>
              <b-col md="6" sm="6" class="my-1">
                <div class="demo-inline-spacing">
                  <b-button v-if="$can('create', 'Sanciones MD')" v-ripple.400="'rgba(255, 255, 255, 0.15)'" v-on:click="mostrarModalSancion()"
                            size="sm" variant="primary">
                    Nuevo
                  </b-button>
                  <b-button v-if="$can('create', 'Sanciones MD')" v-ripple.400="'rgba(255, 255, 255, 0.15)'" v-on:click="subidaMasivaSancion()"
                            size="sm" variant="warning">
                    Subida Masiva de Sanciones
                  </b-button>
                  <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" size="sm" variant="secondary"
                            v-on:click="descargarSanciones()">
                    <a style="color:white;">
                      <feather-icon icon="DownloadIcon" />
                      <span> Descargar Sanciones</span>
                    </a>
                  </b-button>
                </div>
              </b-col>

              <b-col md="6" class="my-1">
                <b-form-group label="Buscar" label-cols-sm="3" label-align-sm="right" label-size="sm"
                              label-for="filterInput" class="mb-0">
                  <b-input-group size="sm">
                    <b-form-input id="filterInput" v-model="filter" type="search"
                                  placeholder="Escribe para buscar" />
                  </b-input-group>
                </b-form-group>
              </b-col>


              <b-col cols="12">
                <b-table ref="selectableTable" selectable small="small" responsive :per-page="perPage"
                         :current-page="currentPage" :items="sanciones" :fields="fieldsSanciones"
                         :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                         :filter="filter" :filter-included-fields="filterOn" @filtered="onFilteredSanciones"
                         :select-mode="selectModeSanciones" @row-selected="onRowSancionesSelected"
                         :busy="cargandoSanciones" show-empty>

                  <template #empty="scope">
                    <div role="alert" aria-live="polite">
                      <div class="text-center my-2">No hay registros para mostrar</div>
                    </div>
                  </template>
                  <template #emptyfiltered="scope">
                    <div role="alert" aria-live="polite">
                      <div class="text-center my-2">No hay registros que coincidan con su solicitud
                      </div>
                    </div>
                  </template>

                  <template #table-busy>
                    <div class="text-center text-dark my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong> Cargando...</strong>
                    </div>
                  </template>

                  <template #cell(id)="data">
                    {{ zeroFill(data.item.involucrado_id, 5) }}
                  </template>

                  <template #cell(descripcion_estado_sancion)="data">
                    <b-badge pill :variant="data.item.estado_sancion_color">
                      {{ data.value }}
                    </b-badge>
                  </template>

                  <template #cell(cant_dias)="data">
                    {{ verificar_dia(data.value) }}
                  </template>

                  <template #cell(fecha_creacion)="data">
                    {{ format_date(data.value) }}
                  </template>

                  <template #cell(empresa)="data">
                    {{ calcular_duracion(data.item.fecha_creacion) }}
                  </template>

                  <template #cell(involucrado_id)="data">
                    <b-input-group-append>
                      <b-button v-if="$can('delete', 'Sanciones MD')" v-ripple.400="'rgba(40, 199, 111, 0.15)'" variant="flat-danger"
                                class="btn-icon"
                                v-on:click="eliminarSancionadoInvolucrado(data.item.id, data.item.ultimo_estado_sancion_id, data.item.ultimo_tipo_sancion_id, data.value)">
                        <feather-icon icon="TrashIcon" />
                      </b-button>
                    </b-input-group-append>
                  </template>

                </b-table>
              </b-col>

              <b-col md="7" sm="8" class="my-1">
                <b-form-group class="mb-0">
                  <label class="d-inline-block text-sm-left mr-50">Por Página</label>
                  <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions"
                                 class="w-50" />
                </b-form-group>
              </b-col>

              <b-col md="5" class="my-1">
                <b-pagination v-model="currentPage" :total-rows="totalRowsSanciones" :per-page="perPage"
                              align="center" size="sm" class="my-0" />
              </b-col>
            </b-row>

          </b-card>

        </div>

      </div>




    </div>

  </template>

  <script>
  import axiosIns from '../../../libs/axios'
  import { VueAutosuggest } from 'vue-autosuggest'
  import {
    BCard, BButton, BRow, BCol, BFormGroup, BInputGroupPrepend, BInputGroup, BFormDatepicker,
    BFormInput, BInputGroupAppend, BFormSelect, BTable, BPagination, BBadge, BCardText,
    BSpinner, BForm, BAvatar, BTabs, BTab, BFormFile, BListGroup, BListGroupItem,
  } from 'bootstrap-vue'
  import Cleave from 'vue-cleave-component'
  import 'cleave.js/dist/addons/cleave-phone.us'
  import moment from 'moment'
  import Ripple from 'vue-ripple-directive'
  import { ValidationProvider, ValidationObserver } from 'vee-validate'
  import vSelect from 'vue-select'
  import Swal from 'sweetalert2'

  import {
    required, email, confirmed, url, between, alpha, integer, password, min, digits, alphaDash, length,
  } from '@validations'

  export default {
    components: {
      VueAutosuggest,
      ValidationProvider, ValidationObserver,
      BCard, BButton, BRow, BCol, BFormGroup, BInputGroupPrepend, BInputGroup, Cleave, BFormDatepicker,
      BFormInput, BInputGroupAppend, BFormSelect, BTable, BPagination, BBadge, BCardText,
      BSpinner, BForm, BAvatar, BTabs, BTab, BFormFile, BListGroup, BListGroupItem,
      vSelect, Swal

    },
    directives: {
      Ripple,
    },
    data() {
      return {
        cargandoSanciones: false,
        mensajeErrorReportadoPor: '',
        mensajeErrorInvolucrados: '',

        ////////////////////////////////////////
        txtFechaDesde: moment().format('YYYY-MM-DD'),
        txtFechaHasta: moment().format('YYYY-MM-DD'),

        selectedEmpresa: null,
        optionsEmpresa: [],
        departamentos: [],

        selectedCultivo: 'TODOS',
        optionsCultivo: [],

        selectedFundo: 'TODOS',
        optionsFundo: [],

        selectedLugar: 'TODOS',
        optionsLugar: [],

        selectedCategoria: 'TODAS',
        optionsCategoria: [],

        selectedEstado: 'TODOS',
        optionsEstado: [],

        sanciones: [],
        perPage: 5,
        currentPage: 1,
        fieldsSanciones: [
          { key: 'involucrado_id', label: 'Opciones', sortable: true, stickyColumn: true, isRowHeader: true },
          { key: 'fecha_creacion', label: 'Fecha Registro', sortable: true },
          { key: 'id', label: 'N° Sancion', sortable: true },
          { key: 'descripcion_estado_sancion', label: 'Estado', sortable: true },
          { key: 'descripcion_categoria', label: 'Categoria', sortable: true },
          //{ key: 'empresa', label: 'Empresa', sortable: true },
          //{ key: 'fundo', label: 'Fundo', sortable: true },
          { key: 'lugar', label: 'Lugar ó Sección', sortable: true },
          //{ key: 'etapa', label: 'Etapa', sortable: true },
          //{ key: 'campo', label: 'Campo', sortable: true },
          { key: 'descripcion', label: 'Descripcion', sortable: true },
          { key: 'nombre_involucrado', label: 'Involucrado', sortable: true },
          { key: 'nombre_evaluador', label: 'Evaluador', sortable: true },
          //{ key: 'dni_reporta_incidente', label: 'Persona Reporta Incidente', sortable: true },


          //{ key: 'descripcion_sub_categoria', label: 'Sub Categoria', sortable: true },
          { key: 'descripcion_tipo_sancion', label: 'Tipo de Sanción', sortable: true },
          { key: 'cant_dias', label: 'Cant. Dias', sortable: true },
          { key: 'empresa', label: 'Duración', sortable: true },
        ],
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        totalRowsSanciones: 1,
        pageOptions: [3, 5, 10],
        selectModeSanciones: 'single',

        nombre_apellido: "",

        trabajadores: [],
        trabajadoresXEmpresa: [],

        /*MODAL*/
        categoria: '',
        subcategoria: '',
        subcategorias: [],

        selectedCategoriaGuardar: null,
        optionsCategoriaGuardar: [],

        selectedSubCategoriaGuardar: null,
        optionsSubCategoriaGuardar: [],

        selectedReportadoPorGuardar: null,
        optionsReportadoPorGuardar: [],

        selectedInvolucradoGuardar: [],
        optionsInvolucradoGuardar: [],

        required,

        btnGrabarMatriz: "",
        titleModalMatriz: "",

        selected: null,

        filteredOptionsTrabajadorReportado: [],
        queryTrabajadorReportado: "",

        filteredOptionsInvolucrado: [],
        queryInvolucrado: "",

        key_empresa_sap: '',

        selectedEmpresaGuardar: null,
        optionsEmpresaGuardar: [],

        selectedCultivoGuardar: null,
        optionsCultivoGuardar: [],

        selectedFundoGuardar: null,
        optionsFundoGuardar: [],

        selectedLugarGuardar: null,
        optionsLugarGuardar: [],

        selectedEtapaGuardar: null,
        optionsEtapaGuardar: [],

        selectedCampoGuardar: null,
        optionsCampoGuardar: [],

        descripcion: '',
        observacion: '',

        zonas: [],

        tipoSancion: [],
        matriz: [],
        matrizencontrada: [],

        involucrados: [],
        fechasinvolucrados: [],
        involucradoSeleccionado: '',
        involucradoSeleccionadoCantFechas: 0,

        sancionIdEditar: null,

        filesEv: [],
        filesDe: [],

        erroresregistro: false,

        optionCultivosNoCampo: [],



        ////////////////////////////////////////

      }
    },
    methods: {
      format_date(value) {
        if (value) {
          return moment(String(value)).format('DD/MM/YYYY')
        }
      },
      calcular_duracion(value) {
        if (value) {
          let fecha1 = new Date(String(value));
          let fecha2 = new Date(String(value))

          let resta = fecha2.getTime() - fecha1.getTime()
          // console.log(Math.round(resta / (1000 * 60 * 60 * 24)))

          return Math.round(resta / (1000 * 60 * 60 * 24)) + ' Días'
        }
      },
      verificar_dia(value) {
        if (value) {
          if (value !== "") {
            return value + " Días"
          } else {
            return "No Aplica"
          }
        } else {
          return "No Aplica"
        }
      },
      obtenerTipoSancion() {
        this.tipoSancion = [];

        const config = {
          method: 'get',
          url: '/sap/md/mdtiposancion/list/',
        };

        axiosIns(config)
            .then((response) => {
              if (response.status === 200) {
                this.tipoSancion = response.data;
              }
            })
            .catch((error) => {
              //console.log(error);
              console.log("=======error======= obtenerTipoSancion");
              // this.obtenerTipoSancion();
            });
      },
      obtenerCategorias() {
        this.optionsCategoria = [];
        const arrayCategoria = [];

        //let optionsTemporal = await getCategorias();
        const config = {
          method: 'get',
          url: '/sap/md/categoria/list/',
        };

        axiosIns(config)
            .then((response) => {
              if (response.status === 200) {
                let optionsTemporal = response.data;
                arrayCategoria.push({ value: 'TODAS', text: 'TODAS' });

                optionsTemporal.filter((item) => {
                  arrayCategoria.push({ value: item.id, text: item.descripcion });
                  this.optionsCategoriaGuardar.push({ value: item.id, text: item.descripcion });
                });

                this.optionsCategoria = arrayCategoria;

              }
              //console.log(JSON.stringify(response.data));
            })
            .catch((error) => {
              //console.log(error);
              console.log("=======error======= obtenerCategorias");
              // this.obtenerCategorias();
            });
      },
      obtenerDepartamentos() {
        this.departamentos = [];

        const config = {
          method: 'get',
          url: '/sap/md/mdsancion/listdepartementos/',
        };

        axiosIns(config)
            .then((response) => {
              if (response.status === 200) {
                this.departamentos = response.data.response;
              }
              //console.log(JSON.stringify(response.data));
            })
            .catch((error) => {
              //console.log(error);
              console.log("=======error======= obtenerDepartamentos");
              // this.obtenerDepartamentos();
            });
      },
      obtenerSubCategorias() {
        this.subcategorias = [];

        const config = {
          method: 'get',
          url: '/sap/md/subcategoria/list/',
        };

        axiosIns(config)
            .then((response) => {
              if (response.status === 200) {
                this.subcategorias = response.data;
                //console.log(this.subcategorias);
              }
            })
            .catch((error) => {
              //console.log(error);
              console.log("=======error======= obtenerSubCategorias");
              // this.obtenerSubCategorias();
            });
      },
      obtenerEstados() {
        this.optionsEstado = [];
        const arrayEstado = [];
        arrayEstado.push({ value: 'TODOS', text: 'TODOS' });

        //let optionsTemporal = await getEstados();

        var config = {
          method: 'get',
          url: '/sap/md/mdestadosancion/list/',
        };

        axiosIns(config).then((response) => {

          if (response.status === 200) {
            let optionsTemporal = response.data;

            optionsTemporal.filter((item) => {
              arrayEstado.push({ value: item.id, text: item.descripcion });
            });

            this.optionsEstado = arrayEstado;

          }

        }).catch((error) => {
          //console.log(error);
          console.log("=======error======= obtenerEstados");
          // this.obtenerEstados();
        });

        /*const objData = JSON.stringify(optionsTemporal);
        const arrayData = JSON.parse(objData);

        arrayData.filter(function (item) {
            arrayEstado.push({ value: item.id, text: item.descripcion });
        });

        this.optionsEstado = arrayEstado;*/
      },
      obtenerSanciones() {
        this.cargandoSanciones = true;
        this.sanciones = [];
        //this.sanciones = await getSanciones(this.txtFechaDesde, this.txtFechaHasta, this.selectedEmpresa, this.selectedCategoria, this.selectedEstado);

        var FormData = require('form-data');
        var data = new FormData();
        data.append('fecha_inicio', this.txtFechaDesde);
        data.append('fecha_fin', this.txtFechaHasta);
        data.append('empresa', this.selectedEmpresa);
        data.append('cultivo', this.selectedCultivo);
        data.append('fundo', this.selectedFundo);
        data.append('lugar', this.selectedLugar);
        data.append('categoria_id', this.selectedCategoria);
        data.append('ultimo_estado_sancion_id', this.selectedEstado);

        var config = {
          method: 'post',
          url: '/sap/md/mdsancion/listfiltro/',
          data: data
        };

        axiosIns(config)
            .then((response) => {
              //console.log(JSON.stringify(response.data.response));
              //return response.data.response;
              if (response.status === 200) {
                this.sanciones = response.data.response;
                this.totalRowsSanciones = this.sanciones.length;
                //console.log(this.sanciones);
              }
            })
            .catch((error) => {
              //console.log(error);
              console.log("=======error======= obtenerSanciones");
              //this.obtenerSanciones();
            })
            .finally(() => {
              this.cargandoSanciones = false;
            });

      },
      onFilteredSanciones(filteredItems) {
        this.totalRowsSanciones = filteredItems.length
        this.currentPage = 1
      },
      onRowSancionesSelected(items) {
        //console.log(items[0]["id"]);
        this.$router.push('/saciones-gestionar-meddisciplinarias-page/' + items[0]["id"]);
        //this.$refs['modal-proceso-falta'].show();
        /*this.selectedCategoria = items[0];
        this.subcategorias = [];
        this.obtenerSubCategorias();*/
      },
      zeroFill(number, width) {
        width -= number.toString().length;
        if (width > 0) {
          return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
        }
        return number + ""; // siempre devuelve tipo cadena
      },
      mostrarSelectEmpresa() {
        if (this.key_empresa_sap === "PE10") { //AGROVISION
          this.selectedEmpresa = 'AGROVISIÓN PERÚ S.A.C'
          this.optionsEmpresa = [
            { value: 'AGROVISIÓN PERÚ S.A.C', text: 'AGROVISIÓN PERÚ S.A.C' },
          ]

          this.selectedEmpresaGuardar = ''
          this.optionsEmpresaGuardar = [
            { value: 'AGROVISIÓN PERÚ S.A.C', text: 'AGROVISIÓN PERÚ S.A.C' },
          ]
        }

        if (this.key_empresa_sap === "PE20") { //ARENA VERDE
          this.selectedEmpresa = 'ARENA VERDE'
          this.optionsEmpresa = [
            { value: 'ARENA VERDE', text: 'ARENA VERDE' },
          ]

          this.selectedEmpresaGuardar = ''
          this.optionsEmpresaGuardar = [
            { value: 'ARENA VERDE', text: 'ARENA VERDE' },
          ]
        }
        this.mostrarCultivoFiltro();

      },
      obtenerEmpresa() {
        const valor = JSON.parse(localStorage.getItem('userData'));
        console.log('valor de la session ',valor.dni)

        var config = {
          method: 'get',
          url: '/sap/md/getPersonal/?dni=' + valor.dni,
        };

        axiosIns(config)
            .then((response) => {
              if (response.status === 200) {
                if (response.data.status === true) {
                  const order = 1;
                  const trabajador = response.data.response;

                  if (trabajador.length !== 0) {
                    trabajador.sort((a, b) => {
                      a = new Date(a.fecha_ingreso);
                      b = new Date(b.fecha_ingreso);
                      var results = a > b ? -1 : a < b ? 1 : 0;
                      return results * order;
                    });
                    this.key_empresa_sap = trabajador[0].key_empresa_sap;
                  }

                }

              }

            })
            .catch((error) => {
              console.log(error);
              console.log("=======error======= obtenerEmpresa");
              // this.obtenerEmpresa();
            })
            .finally(() => {
              this.mostrarSelectEmpresa()
              this.obtenerTrabajadores()
            });
      },
      mostrarModalSancion() {

        this.sancionIdEditar = null;

        this.titleModalMatriz = "Crear Sancion";
        this.btnGrabarMatriz = "Crear";

        this.$refs['my-modal-matriz'].show();

      },
      obtenerListMatriz() {
        this.matriz = [];

        var config = {
          method: 'get',
          url: '/sap/md/mdmatriz/list/',
        };

        axiosIns(config)
            .then((response) => {
              if (response.status === 200) {
                this.matriz = response.data;
              }
            })
            .catch((error) => {
              //console.log(error);
              console.log("=======error======= obtenerListMatriz");
              // this.obtenerListMatriz();
            })
            .finally(() => {

            });

      },
      obtenerMatriz() {
        this.fechasinvolucrados = [];
        this.involucrados = [];
        this.matrizencontrada = [];
        this.mensajeErrorInvolucrados = '';
        this.selectedInvolucradoGuardar = [];

        this.queryInvolucrado = "";

        this.matriz.filter((item) => {
          if (item.categoria === this.selectedCategoriaGuardar && item.subcategoria === this.selectedSubCategoriaGuardar) {
            this.matrizencontrada.push(item);
          }
        });
      },
      mostrarSubCategoria() {

        this.obtenerMatriz();

        this.optionsSubCategoriaGuardar = [];

        this.subcategorias.filter((item) => {
          if (item.categoria === this.selectedCategoriaGuardar) {
            this.optionsSubCategoriaGuardar.push({ value: item.id, text: item.descripcion });
          }
        });
      },
      resetModalMatriz() {
        /*this.descripcion = ''
        this.descripcionStateCategoria = null*/
      },
      handleOkMatriz(bvModalEvt) {
        bvModalEvt.preventDefault()
        /*this.$refs.simpleRules.validate().then(success => {
            if (success) {*/

        if (this.sancionIdEditar != null) {
          //this.editarSancion();
        } else {

          if(!this.validarErroresRegistroSancion(1)){
            this.crearSancion();
          }



        }
        /*}
    })*/
      },
      validarErroresRegistroSancion(tipo){

        if (this.selectedCategoriaGuardar === null) {
          Swal.fire({
            title: 'Advertencia!',
            text: ' Debe seleccionar Categoria ',
            icon: 'warning',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })

          return true;
        }

        if (this.selectedSubCategoriaGuardar === null) {
          Swal.fire({
            title: 'Advertencia!',
            text: ' Debe seleccionar Sub Categoria ',
            icon: 'warning',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })

          return true;
        }

        if (this.selectedReportadoPorGuardar === null) {
          Swal.fire({
            title: 'Advertencia!',
            text: ' Debe seleccionar Reportado Por ',
            icon: 'warning',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })

          return true;
        }

        if (this.selectedReportadoPorGuardar.length === 0) {
          Swal.fire({
            title: 'Advertencia!',
            text: ' Debe seleccionar Reportado Por ',
            icon: 'warning',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })

          return true;
        }

        if (this.selectedEmpresaGuardar === null || this.selectedEmpresaGuardar === '') {
          Swal.fire({
            title: 'Advertencia!',
            text: ' Debe seleccionar Empresa ',
            icon: 'warning',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })

          return true;
        }

        if (this.selectedCultivoGuardar === null || this.selectedCultivoGuardar === '') {
          Swal.fire({
            title: 'Advertencia!',
            text: ' Debe seleccionar Cultivo ',
            icon: 'warning',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })

          return true;
        }

        if(this.key_empresa_sap === 'PE10'){

          if (this.selectedFundoGuardar === null || this.selectedFundoGuardar === '') {
            Swal.fire({
              title: 'Advertencia!',
              text: ' Debe seleccionar Fundo ',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })

            return true;
          }

          if (this.selectedLugarGuardar === null || this.selectedLugarGuardar === '') {
            Swal.fire({
              title: 'Advertencia!',
              text: ' Debe seleccionar Lugar ',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })

            return true;
          }

        }

        if (this.selectedLugarGuardar === "CAMPO") {
          if (this.selectedEtapaGuardar === null || this.selectedEtapaGuardar === '') {
            Swal.fire({
              title: 'Advertencia!',
              text: ' Debe seleccionar Etapa ',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })

            return true;
          }

          if (this.selectedCampoGuardar === null || this.selectedCampoGuardar === '') {
            Swal.fire({
              title: 'Advertencia!',
              text: ' Debe seleccionar Campo ',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })

            return true;
          }
        }

        if (this.descripcion === '') {
          Swal.fire({
            title: 'Advertencia!',
            text: ' Debe escribir Descripción ',
            icon: 'warning',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })

          return true;
        }

        const cant = this.filesEv.length + this.filesDe.length;
        if (cant === 0) {
          Swal.fire({
            title: 'Advertencia!',
            text: ' Debe agregar Evidencias o Descargos ',
            icon: 'warning',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })

          return true;
        }

        if(tipo === 1){
          if (this.involucrados.length === 0) {
            Swal.fire({
              title: 'Advertencia!',
              text: ' Debe agregar Involucrados ',
              icon: 'warning',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
            return true;
          }
        }

        return false;

      },
      crearSancion() {
        var fechaActual = moment().format('YYYY-MM-DD H:mm:ss');

        //this.registrarArchivosEvidencia(6, 1, null, fechaActual)

        const valor = JSON.parse(localStorage.getItem('userData'));

        var data = {
          "categoria": this.selectedCategoriaGuardar,
          "subcategoria": this.selectedSubCategoriaGuardar,
          "empresa": this.selectedEmpresaGuardar,
          "cultivo": this.selectedCultivoGuardar,
          "fundo": this.selectedFundoGuardar,
          "lugar": this.selectedLugarGuardar,
          "etapa": this.selectedEtapaGuardar,
          "campo": this.selectedCampoGuardar,
          "dni_evaluador": valor.dni,
          "nombre_evaluador": valor.fullName,
          "dni_reporta_incidente": this.selectedReportadoPorGuardar.numero_documento,
          "nombre_reporta_incidente": this.selectedReportadoPorGuardar.nombres + " " + this.selectedReportadoPorGuardar.apellido_paterno + " " + this.selectedReportadoPorGuardar.apellido_materno,
          "nombre_cargo_reporta_incidente": this.selectedReportadoPorGuardar.nombre_cargo,
          "area_reporta_incidente": this.selectedReportadoPorGuardar.area,

          "fecha_ingreso_reporta_incidente": this.selectedReportadoPorGuardar.fecha_ingreso,
          "key_sede_reporta_incidente": this.selectedReportadoPorGuardar.key_sede,
          "departamento_reporta_incidente": this.selectedReportadoPorGuardar.departamento,
          "seccion_reporta_incidente": this.selectedReportadoPorGuardar.seccion,
          "genero_reporta_incidente": this.selectedReportadoPorGuardar.genero,
          "fecha_nacimiento_reporta_incidente": this.selectedReportadoPorGuardar.fecha_nacimiento,


          "fecha_creacion": fechaActual,
          "fecha_actualizacion": fechaActual,
          "estado": "1"
        };

        var config = {
          method: 'post',
          url: '/sap/md/mdsancion/crear/',
          data: data
        };

        axiosIns(config)
            .then((response) => {
              this.registrarInvolucrados(response.data.id, fechaActual);

            })
            .catch((error) => {
              //console.log(error);
              this.erroresregistro = true;
              this.errorRegistro("Sanción");
            }).finally(() => {
          if (this.erroresregistro === false) {
            this.obtenerSanciones();

            this.$nextTick(() => {
              this.$refs['my-modal-matriz'].toggle('#toggle-btn')
            })

            this.successRegistro("Sanción");
          } else {
            this.errorRegistro("Sanción");
          }

        });


      },
      registrarInvolucrados(idSancion, fechaActual) {

        this.involucrados.forEach((value, index) => {
          //console.log(this.descripcion);
          var data = {
            "sancion": idSancion,
            "ultimo_estado_sancion": value.ultimo_estado_sancion,
            "ultimo_tipo_sancion": value.ultimo_tipo_sancion,
            "descripcion": this.descripcion,
            "cant_dias": value.cant_dias,
            "dni_involucrado": value.dni_involucrado,
            "nombre_involucrado": value.nombre_involucrado,
            "nombre_cargo_involucrado": value.nombre_cargo_involucrado,
            "area_involucrado": value.area_involucrado,

            "fecha_ingreso_involucrado": value.fecha_ingreso_involucrado,
            "key_sede_involucrado": value.key_sede_involucrado,
            "departamento_involucrado": value.departamento_involucrado,
            "seccion_involucrado": value.seccion_involucrado,
            "firmo_papeleta_involucrado": value.firmo_papeleta_involucrado,
            "observacion_involucrado": value.observacion_involucrado,
            "genero_involucrado": value.genero_involucrado,
            "fecha_nacimiento_involucrado": value.fecha_nacimiento_involucrado,

            "fecha_creacion": fechaActual,
            "fecha_actualizacion": fechaActual,
            "estado": "1"
          };

          var config = {
            method: 'post',
            url: '/sap/md/mdinvolucrado/crear/',
            data: data
          };

          axiosIns(config)
              .then((response) => {
                this.registrarFechasSancion(idSancion, response.data.id, value, fechaActual);
                this.registrarHistorialEvento(idSancion, response.data.id, value, fechaActual);

                this.obtenerSanciones();
              })
              .catch((error) => {
                this.erroresregistro = true;
                //this.errorRegistro("Sanción");
              });


        });

      },
      registrarFechasSancion(idSancion, idInvolucrado, value, fechaActual) {

        const filtersList = this.fechasinvolucrados.filter(element => element.dni_involucrado === value.dni_involucrado)

        filtersList.forEach((item, index) => {

          var data = {
            "involucrado": idInvolucrado,
            "nro_dia": item.nro_dia,
            "fecha_sancion": item.fecha_sancion,
            "fecha_creacion": fechaActual,
            "fecha_actualizacion": fechaActual,
            "estado": "1"
          };

          var config = {
            method: 'post',
            url: '/sap/md/mdfechasancioninvolucrado/crear/',
            data: data
          };

          axiosIns(config)
              .then((response) => {
                //console.log(response.data);
              })
              .catch((error) => {
                this.erroresregistro = true;
                //this.errorRegistro("Sanción");
              });

        });

      },
      registrarHistorialEvento(idSancion, idInvolucrado, value, fechaActual) {

        var data = {
          "involucrado": idInvolucrado,
          "estado_sancion": value.ultimo_estado_sancion,
          "tipo_sancion": value.ultimo_tipo_sancion,
          "cant_dias": value.cant_dias,
          "descripcion": "Registrado desde la WEB",
          "fecha_creacion": fechaActual,
          "fecha_actualizacion": fechaActual,
          "estado": "1"
        };

        var config = {
          method: 'post',
          url: '/sap/md/mdhistorialevento/crear/',
          data: data
        };

        axiosIns(config)
            .then((response) => {
              //console.log(response.data);
              this.registrarArchivosEvidencia(idSancion, response.data.id, value, fechaActual);
              this.registrarArchivosDescargo(idSancion, response.data.id, value, fechaActual);
            })
            .catch((error) => {
              this.erroresregistro = true;
              //this.errorRegistro("Sanción");
            });

      },
      registrarArchivosEvidencia(idSancion, idHistorialEvento, value, fechaActual) {

        this.filesEv.forEach((item, index) => {

          var FormData = require('form-data');

          var data = new FormData();
          data.append('historial_evento', idHistorialEvento);
          data.append('file', item);
          data.append('tipo_archivo', 'ARCHIVOS');
          data.append('tipo_registro', 'EVIDENCIA');
          data.append('fecha_creacion', fechaActual);
          data.append('estado', '1');

          var config = {
            method: 'post',
            url: '/sap/md/mdarchivo/crear/',
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: data
          };

          axiosIns(config)
              .then((response) => {

              })
              .catch((error) => {
                this.erroresregistro = true;
                //this.errorRegistro("Sanción");
              });

        });

      },
      registrarArchivosDescargo(idSancion, idHistorialEvento, value, fechaActual) {

        this.filesDe.forEach((item, index) => {

          var FormData = require('form-data');

          var data = new FormData();
          data.append('historial_evento', idHistorialEvento);
          data.append('file', item);
          data.append('tipo_archivo', 'ARCHIVOS');
          data.append('tipo_registro', 'DESCARGO');
          data.append('fecha_creacion', fechaActual);
          data.append('estado', '1');

          var config = {
            method: 'post',
            url: '/sap/md/mdarchivo/crear/',
            headers: {
              'Content-Type': 'multipart/form-data'
            },
            data: data
          };

          axiosIns(config)
              .then((response) => {

              })
              .catch((error) => {
                this.erroresregistro = true;
                //this.errorRegistro("Sanción");
              });

        });

      },
      successRegistro(texto) {
        Swal.fire({
          title: 'Registro exitoso!',
          text: texto + ' se registro de manera satisfactoria!',
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        });
      },
      errorRegistro(texto) {
        Swal.fire({
          title: 'Error!',
          text: texto + ' Registro fallido',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      },
      obtenerTrabajadores() {
        this.trabajadores = [];
        this.trabajadoresXEmpresa = [];
        this.optionCultivosNoCampo = [];
        this.datasuggest = [];

        var config = {
          method: 'get',
          url: '/sap/md/getPersonal/',
        };

        axiosIns(config)
            .then((response) => {
              if (response.status === 200) {
                if (response.data.status === true) {

                  const order = 1;
                  const trabajadoresUnicos = [];

                  this.trabajadores = response.data.response;

                  this.trabajadores.filter((item) => {
                    if (item.nombre_cargo !== 'OBRERO AGRARIO' && item.seccion !== '' && item.key_empresa_sap === this.key_empresa_sap) {
                      if (this.optionCultivosNoCampo.findIndex(element => element.value === item.seccion) === -1) {
                        this.optionCultivosNoCampo.push({ value: item.seccion, text: item.seccion });
                      }
                    }
                  });

                  this.optionCultivosNoCampo.sort((a, b) => {
                    const valueA = a.value;
                    const valueB = b.value;
                    if (valueA < valueB) {
                      return -1;
                    }
                    if (valueA > valueB) {
                      return 1;
                    }
                    return 0;
                  });

                }

              }

            })
            .catch((error) => {
              //console.log(error);
              console.log("=======error======= obtenerTrabajadores");
              // this.obtenerTrabajadores();
            })
            .finally(() => {
              this.mostrarCultivo();
              this.mostrarCultivoFiltro();
            });
      },
      onInputChange(text) {
        this.selectedReportadoPorGuardar = [];

        if (text === '' || text === undefined) {
          return
        }

        const filteredGeneral = this.trabajadores.filter((item) => {

          var cadena = item.numero_documento + " | " + item.nombres + " " + item.apellido_paterno + " " + item.apellido_materno;

          return cadena.toLowerCase().indexOf(text.toLowerCase()) > -1;

        }).slice(0, this.limit)

        this.filteredOptionsTrabajadorReportado = [{
          data: filteredGeneral,
        }]
      },
      getTrabajadoresValue(suggestion) {

        this.mensajeErrorReportadoPor = '';

        const order = 1;

        const { item } = suggestion
        this.selectedReportadoPorGuardar = item;

        const trabajadorSeleccionado = [];

        this.trabajadores.filter((item) => {
          if (item.numero_documento === this.selectedReportadoPorGuardar.numero_documento) {
            trabajadorSeleccionado.push(item);
          }
        });

        if (trabajadorSeleccionado.length !== 0) {
          trabajadorSeleccionado.sort((a, b) => {
            a = new Date(a.fecha_ingreso);
            b = new Date(b.fecha_ingreso);
            var results = a > b ? -1 : a < b ? 1 : 0;
            return results * order;
          });
          this.selectedReportadoPorGuardar = trabajadorSeleccionado[0];
        }

        if (this.selectedReportadoPorGuardar.key_empresa_sap === this.key_empresa_sap) {
          this.queryTrabajadorReportado = item.numero_documento + " | " + item.nombres + " " + item.apellido_paterno + " " + item.apellido_materno;

          return item.numero_documento + " | " + item.nombres + " " + item.apellido_paterno + " " + item.apellido_materno
        } else {

          this.selectedReportadoPorGuardar = [];

          this.queryTrabajadorReportado = "";

          this.mensajeErrorReportadoPor = "Trabajador seleccionado no se encuentra laborando actualmente en " + this.selectedEmpresa;

          return "";
          //return "Trabajador no se encuentra laborando actualmente en "+this.selectedEmpresa;

        }


      },
      obtenerZonas() {
        this.zonas = [];

        var config = {
          method: 'get',
          url: '/pagricolas/data_lineal/',
          headers: {}
        };

        axiosIns(config)
            .then((response) => {
              if (response.status === 200) {
                this.zonas = response.data;
              }
            })
            .catch((error) => {
              //console.log(error);
              console.log("=======error======= obtenerZonas");
              // this.obtenerZonas();
            })
            .finally(() => {
              this.mostrarCultivo();
              this.mostrarCultivoFiltro();
            });
      },
      mostrarCultivo() {
        this.selectedCultivoGuardar = null;
        this.optionsCultivoGuardar = [];

        this.selectedFundoGuardar = null;
        this.optionsFundoGuardar = [];

        this.selectedLugarGuardar = null;
        this.optionsLugarGuardar = [];

        this.selectedEtapaGuardar = null;
        this.optionsEtapaGuardar = [];

        this.selectedCampoGuardar = null;
        this.optionsCampoGuardar = [];

        const optionsCultivoGuardarTemp = [];

        this.zonas.filter((item) => {
          if (item.sociedad === this.selectedEmpresaGuardar) {
            if (optionsCultivoGuardarTemp.indexOf(item.cultivo) < 0) {
              optionsCultivoGuardarTemp.push(item.cultivo);
              this.optionsCultivoGuardar.push({ value: item.cultivo, text: item.cultivo });
            }
          }
        });

        this.departamentos.filter((item) => {
          if (this.selectedEmpresaGuardar !== "") {
            if (optionsCultivoGuardarTemp.indexOf(item.departamento) < 0) {
              optionsCultivoGuardarTemp.push(item.departamento);
              this.optionsCultivoGuardar.push({ value: item.departamento, text: item.departamento });
            }
          }
        });

        if(this.key_empresa_sap === 'PE20'){
          this.optionsCultivoGuardar = this.optionCultivosNoCampo;
        }

      },
      mostrarFundo() {
        this.selectedFundoGuardar = null;
        this.optionsFundoGuardar = [];

        this.selectedLugarGuardar = null;
        this.optionsLugarGuardar = [];

        this.selectedEtapaGuardar = null;
        this.optionsEtapaGuardar = [];

        this.selectedCampoGuardar = null;
        this.optionsCampoGuardar = [];

        const optionsFundoGuardarTemp = [];

        this.fechasinvolucrados = [];
        this.involucrados = [];
        this.mensajeErrorInvolucrados = '';
        this.selectedInvolucradoGuardar = [];

        this.zonas.filter((item) => {
          if (item.sociedad === this.selectedEmpresaGuardar && item.cultivo === this.selectedCultivoGuardar) {
            if (optionsFundoGuardarTemp.indexOf(item.fundo) < 0) {
              optionsFundoGuardarTemp.push(item.fundo);
              this.optionsFundoGuardar.push({ value: item.fundo, text: item.fundo });
            }
          }
        });

        this.departamentos.filter((item) => {
          if (item.departamento === this.selectedCultivoGuardar) {
            if (optionsFundoGuardarTemp.indexOf(item.area) < 0) {
              optionsFundoGuardarTemp.push(item.area);
              this.optionsFundoGuardar.push({ value: item.area, text: item.area });
            }
          }
        });
      },
      mostrarLugar() {

        this.selectedLugarGuardar = null;
        this.optionsLugarGuardar = [];

        this.selectedEtapaGuardar = null;
        this.optionsEtapaGuardar = [];

        this.selectedCampoGuardar = null;
        this.optionsCampoGuardar = [];

        const optionsLugarGuardarTemp = [];

        this.departamentos.filter((item) => {
          if (item.departamento === this.selectedCultivoGuardar && item.area === this.selectedFundoGuardar) {
            if (optionsLugarGuardarTemp.indexOf(item.seccion) < 0) {
              optionsLugarGuardarTemp.push(item.seccion);
              this.optionsLugarGuardar.push({ value: item.seccion, text: item.seccion });
            }
          }
        });

        if(this.optionsLugarGuardar.length === 0){
          if (this.key_empresa_sap === "PE10") { //AGROVISION
            this.optionsLugarGuardar = [
              { value: 'CAMPO', text: 'CAMPO' },
              { value: 'Packing Grande', text: 'Packing Grande' },
            ]

            if (this.selectedCultivoGuardar === "ARANDANO") {
              this.optionsLugarGuardar = [];
              this.optionsLugarGuardar = [
                { value: 'CAMPO', text: 'CAMPO' },
                { value: 'Packing Grande', text: 'Packing Grande' },
                { value: 'Packing A9', text: 'Packing A9' },
              ]
            }
            if (this.selectedCultivoGuardar === "ESPÁRRAGO") {
              this.optionsLugarGuardar = [];
              this.optionsLugarGuardar = [
                { value: 'CAMPO', text: 'CAMPO' },
                { value: 'Packing Esparrago', text: 'Packing Esparrago' },
              ]
            }
          }

          if (this.key_empresa_sap === "PE20") { //ARENA VERDE
            this.optionsLugarGuardar = [
              { value: 'CAMPO', text: 'CAMPO' },
            ]
          }
        }

      },
      mostrarEtapa() {

        this.selectedEtapaGuardar = null;
        this.optionsEtapaGuardar = [];

        this.selectedCampoGuardar = null;
        this.optionsCampoGuardar = [];

        const optionsEtapaGuardarTemp = [];

        if (this.selectedLugarGuardar === "CAMPO") {
          this.zonas.filter((item) => {
            if (item.sociedad === this.selectedEmpresaGuardar && item.cultivo === this.selectedCultivoGuardar && item.fundo === this.selectedFundoGuardar) {
              if (optionsEtapaGuardarTemp.indexOf(item.etapa) < 0) {
                optionsEtapaGuardarTemp.push(item.etapa);
                this.optionsEtapaGuardar.push({ value: item.etapa, text: item.etapa });
              }
            }
          });
        }

      },
      mostrarCampo() {

        this.selectedCampoGuardar = null;
        this.optionsCampoGuardar = [];

        const optionsCampoGuardarTemp = [];

        if (this.selectedLugarGuardar === "CAMPO") {
          this.zonas.filter((item) => {
            if (item.sociedad === this.selectedEmpresaGuardar && item.cultivo === this.selectedCultivoGuardar && item.fundo === this.selectedFundoGuardar && item.etapa === this.selectedEtapaGuardar) {
              if (optionsCampoGuardarTemp.indexOf(item.campo) < 0) {
                optionsCampoGuardarTemp.push(item.campo);
                this.optionsCampoGuardar.push({ value: item.campo, text: item.campo });
              }
            }
          });
        }

      },
      generarSancion(involucradoTemp) {

        const filtersList = this.involucrados.filter(element => element.dni_involucrado === involucradoTemp.numero_documento)

        if (filtersList.length === 0) {

          var FormData = require('form-data');
          var data = new FormData();
          data.append('empresa', this.selectedEmpresaGuardar);
          data.append('dni_involucrado', involucradoTemp.numero_documento);
          data.append('categoria', this.selectedCategoriaGuardar);
          data.append('subcategoria', this.selectedSubCategoriaGuardar);
          data.append('cultivo', this.selectedCultivoGuardar);

          var config = {
            method: 'post',
            url: '/sap/md/mdsancion/cantsancionxinvolucrado/',
            data: data
          };

          axiosIns(config)
              .then((response) => {

                if (response.status === 200) {
                  const data = response.data.response;

                  //console.log(data);

                  var idTipoSancionTemp = '';
                  var cantDiasTipoSancionTemp = '';

                  if (data[0].cantidad === 0) {
                    idTipoSancionTemp = this.matrizencontrada[0].tipo_sancion_1;
                    cantDiasTipoSancionTemp = this.matrizencontrada[0].cant_dias_1;
                  }

                  if (data[0].cantidad === 1) {
                    idTipoSancionTemp = this.matrizencontrada[0].tipo_sancion_2;
                    cantDiasTipoSancionTemp = this.matrizencontrada[0].cant_dias_2;
                  }

                  if (data[0].cantidad === 2) {
                    idTipoSancionTemp = this.matrizencontrada[0].tipo_sancion_3;
                    cantDiasTipoSancionTemp = this.matrizencontrada[0].cant_dias_3;
                  }

                  if (data[0].cantidad >= 3) {
                    idTipoSancionTemp = this.matrizencontrada[0].tipo_sancion_4;
                    cantDiasTipoSancionTemp = this.matrizencontrada[0].cant_dias_4;
                  }

                  const filtersTipoSancion = this.tipoSancion.filter(element => element.id === idTipoSancionTemp);

                  this.involucrados.push({
                    sancion: '',
                    ultimo_estado_sancion: "1",
                    ultimo_tipo_sancion: idTipoSancionTemp,
                    descripcion_tipo_sancion: filtersTipoSancion[0].descripcion,
                    cant_dias: cantDiasTipoSancionTemp,
                    dni_involucrado: involucradoTemp.numero_documento,
                    nombre_involucrado: involucradoTemp.nombres + " " + involucradoTemp.apellido_paterno + " " + involucradoTemp.apellido_materno,
                    nombre_cargo_involucrado: involucradoTemp.nombre_cargo,
                    area_involucrado: involucradoTemp.area,

                    fecha_ingreso_involucrado: involucradoTemp.fecha_ingreso,
                    key_sede_involucrado: involucradoTemp.key_sede,
                    departamento_involucrado: involucradoTemp.departamento,
                    seccion_involucrado: involucradoTemp.seccion,
                    firmo_papeleta_involucrado: 'NO',
                    observacion_involucrado: this.observacion,
                    genero_involucrado: involucradoTemp.genero,
                    fecha_nacimiento_involucrado: involucradoTemp.fecha_nacimiento,

                    fecha_creacion: '',
                    fecha_actualizacion: '',
                    estado: '1'
                  });

                  var fechaInicialST = moment().add({ days: 0 }).format('YYYY-MM-DD');

                  this.calcularFechasXinvolucrado(involucradoTemp.numero_documento, 0, fechaInicialST, cantDiasTipoSancionTemp);
                  //console.log(this.fechasinvolucrados);

                  //fechasinvolucrados
                }
              })
              .catch((error) => {
                console.log(error);
              });


        }

      },
      getInvolucradosValue(suggestion) {

        this.mensajeErrorInvolucrados = '';
        const order = 1;

        const { item } = suggestion
        this.selectedInvolucradoGuardar = item;

        const invoTemp = [];

        this.trabajadores.filter((item) => {
          if (item.numero_documento === this.selectedInvolucradoGuardar.numero_documento) {
            invoTemp.push(item);
          }
        });

        if (invoTemp.length !== 0) {
          invoTemp.sort((a, b) => {
            a = new Date(a.fecha_ingreso);
            b = new Date(b.fecha_ingreso);
            var results = a > b ? -1 : a < b ? 1 : 0;
            return results * order;
          });
          this.selectedInvolucradoGuardar = invoTemp[0];
        }

        if (this.selectedInvolucradoGuardar.key_empresa_sap === this.key_empresa_sap) {

          if(!this.validarErroresRegistroSancion(2)){
            this.generarSancion(this.selectedInvolucradoGuardar);

            this.queryInvolucrado = item.numero_documento + " | " + item.nombres + " " + item.apellido_paterno + " " + item.apellido_materno;

            return item.numero_documento + " | " + item.nombres + " " + item.apellido_paterno + " " + item.apellido_materno
          }else{
            this.selectedInvolucradoGuardar = [];

            this.queryInvolucrado = "";

            this.mensajeErrorInvolucrados = "Debe llenar los campos Generales";

            return "";
          }

        } else {

          this.selectedInvolucradoGuardar = [];

          this.queryInvolucrado = "";

          this.mensajeErrorInvolucrados = "Trabajador seleccionado no se encuentra laborando actualmente en " + this.selectedEmpresa;

          return "";
          //return "Trabajador no se encuentra laborando actualmente en "+this.selectedEmpresa;

        }

        /*this.queryInvolucrado = item.numero_documento + " | " + item.nombres + " " + item.apellido_paterno + " " + item.apellido_materno;

        return item.numero_documento + " | " + item.nombres + " " + item.apellido_paterno + " " + item.apellido_materno*/
      },
      onInputChangeInvolucrado(text) {
        this.selectedInvolucradoGuardar = [];

        if (text === '' || text === undefined) {
          return
        }

        const filteredGeneral = this.trabajadores.filter((item) => {

          var cadena = item.numero_documento + " | " + item.nombres + " " + item.apellido_paterno + " " + item.apellido_materno;

          return cadena.toLowerCase().indexOf(text.toLowerCase()) > -1;

        }).slice(0, this.limit)

        //if (filteredGeneral.length != 0) {
        this.filteredOptionsInvolucrado = [{
          data: filteredGeneral,
        }]
        /*} else {
            this.filteredOptionsTrabajadorReportado = [

            ];
            this.queryTrabajadorReportado = '';
        }*/
      },
      mostrarDetalleFechas(dni_involucrado) {

        if (this.involucradoSeleccionado === dni_involucrado) {
          this.involucradoSeleccionado = '';
        } else {
          this.involucradoSeleccionado = dni_involucrado;
        }

        const filtersList = this.fechasinvolucrados.filter(element => element.dni_involucrado === this.involucradoSeleccionado)
        this.involucradoSeleccionadoCantFechas = filtersList.length;

      },
      eliminarInvolucrado(dni_involucrado) {
        const filtersList = this.involucrados.filter(element => element.dni_involucrado !== dni_involucrado)
        this.involucrados = filtersList

        const filtersList2 = this.fechasinvolucrados.filter(element => element.dni_involucrado !== dni_involucrado)
        this.fechasinvolucrados = filtersList2

        this.involucradoSeleccionadoCantFechas = 0;
      },
      calcularFechasXinvolucrado(dni_involucrado, tipo, fechaInicialST, cant_dias) {
        //tipo:  0 => automatico, 1 => manual

        //var fechaInicialST = moment().add({ days: 1 }).format('YYYY-MM-DD');
        if (tipo === 1) {

        }

        var inputFecha = "";

        var diasSuma = 0;

        var nroweekday = 11111;

        for (var i = 0; i < cant_dias - tipo; i++) {

          diasSuma = 1;
          nroweekday = 11111;

          while (nroweekday === 11111 || nroweekday === 0) {

            //var fechaActualD = moment(fechaInicialST).format('YYYY-MM-DD');
            var fechaActualD = fechaInicialST;

            var fechaTemp = moment(fechaActualD).add({ days: diasSuma });

            nroweekday = fechaTemp.get('weekday');
            fechaActualD = fechaTemp.format('YYYY-MM-DD');

            inputFecha = fechaActualD;

            //diasSuma++;

            fechaInicialST = inputFecha;

          }

          this.fechasinvolucrados.push({
            involucrado: '',
            dni_involucrado: dni_involucrado,
            nro_dia: i,
            fecha_sancion: fechaInicialST,
            fecha_creacion: '',
            fecha_actualizacion: '',
            estado: '1'
          });

        }
      },

      eliminarSancionadoInvolucrado(sancion, ultimo_estado_sancion, ultimo_tipo_sancion, id) {

        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger'
          },
          buttonsStyling: false
        });

        swalWithBootstrapButtons.fire({
          title: 'Desea eliminar este Registro?',
          text: "No se podrá recuperar después eliminada!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Si, eliminar!',
          cancelButtonText: 'No, cancelar!',
          reverseButtons: true
        }).then((result) => {
          if (result.isConfirmed) {

            this.deleteSancionInvolucrado(sancion, ultimo_estado_sancion, ultimo_tipo_sancion, id);

          } else if (
              result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
                'Cancelado',
                'Tu registro no se elimino!',
                'error'
            )
          }
        });

      },

      deleteSancionInvolucrado(sancion, ultimo_estado_sancion, ultimo_tipo_sancion, id) {

        var data = {
          "sancion": sancion,
          "ultimo_estado_sancion": ultimo_estado_sancion,
          "ultimo_tipo_sancion": ultimo_tipo_sancion,
          "estado": "0"
        };

        var config = {
          method: 'put',
          url: '/sap/md/mdinvolucrado/editar/' + id,
          data: data
        };

        axiosIns(config)
            .then((response) => {
              if (response.status === 200) {

                Swal.fire(
                    'Eliminado!',
                    'Su Registro fue elimnada con éxito!',
                    'success'
                );
                this.obtenerSanciones();
              }
            })
            .catch((error) => {
              console.log(error);
            });

      },
      subidaMasivaSancion() {
        this.$router.push('/saciones-subidamasiva-meddisciplinarias-page/');
      },
      descargarSanciones() {

        var FormData = require('form-data');
        var data = new FormData();
        data.append('fecha_inicio', this.txtFechaDesde);
        data.append('fecha_fin', this.txtFechaHasta);
        data.append('empresa', this.selectedEmpresa);
        data.append('cultivo', this.selectedCultivo);
        data.append('fundo', this.selectedFundo);
        data.append('lugar', this.selectedLugar);
        data.append('categoria_id', this.selectedCategoria);
        data.append('ultimo_estado_sancion_id', this.selectedEstado);

        var config = {
          method: 'post',
          url: '/sap/md/mdsancion/listfiltroexcel/',
          responseType: 'arraybuffer',
          data: data
        };

        axiosIns(config)
            .then((response) => {
              if (response.status === 200) {
                const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                console.log(fileURL);
                const fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', "reporte_sanciones.xlsx");
                document.body.appendChild(fileLink);
                fileLink.click();
              }
            })
            .catch((error) => {
              console.log(error);
            });



      },
      mostrarCultivoFiltro() {
        this.optionsCultivoTemp = [];

        this.selectedCultivo = 'TODOS';
        this.optionsCultivo = [];

        this.selectedFundo = 'TODOS';
        this.optionsFundo = [];

        this.selectedLugar = 'TODOS';
        this.optionsLugar = [];

        const optionsCultivoTemp = [];

        this.optionsCultivo.push({ value: 'TODOS', text: 'TODOS' });

        this.zonas.filter((item) => {
          if (item.sociedad === this.selectedEmpresa) {
            if (optionsCultivoTemp.indexOf(item.cultivo) < 0) {
              optionsCultivoTemp.push(item.cultivo);
              this.optionsCultivo.push({ value: item.cultivo, text: item.cultivo });
            }
          }
        });

        if(this.key_empresa_sap === 'PE20'){
          this.optionsCultivo = this.optionCultivosNoCampo;
        }

        this.departamentos.filter((item) => {
          if (this.selectedEmpresa !== "") {
            if (optionsCultivoTemp.indexOf(item.departamento) < 0) {
              optionsCultivoTemp.push(item.departamento);
              this.optionsCultivo.push({ value: item.departamento, text: item.departamento });
            }
          }
        });

        this.mostrarFundoFiltro();

      },
      mostrarFundoFiltro() {
        this.optionsFundoTemp = [];

        this.selectedFundo = 'TODOS';
        this.optionsFundo = [];

        this.selectedLugar = 'TODOS';
        this.optionsLugar = [];

        const optionsFundoTemp = [];

        this.optionsFundo.push({ value: 'TODOS', text: 'TODOS' });

        if(this.selectedCultivo === 'TODOS'){
          this.zonas.filter((item) => {
            if (item.sociedad === this.selectedEmpresa) {
              if (optionsFundoTemp.indexOf(item.fundo) < 0) {
                optionsFundoTemp.push(item.fundo);
                this.optionsFundo.push({ value: item.fundo, text: item.fundo });
              }
            }
          });

          this.departamentos.filter((item) => {
            if (optionsFundoTemp.indexOf(item.area) < 0) {
              optionsFundoTemp.push(item.area);
              this.optionsFundo.push({ value: item.area, text: item.area });
            }
          });
        }else{
          this.zonas.filter((item) => {
            if (item.sociedad === this.selectedEmpresa && item.cultivo === this.selectedCultivo) {
              if (optionsFundoTemp.indexOf(item.fundo) < 0) {
                optionsFundoTemp.push(item.fundo);
                this.optionsFundo.push({ value: item.fundo, text: item.fundo });
              }
            }
          });

          this.departamentos.filter((item) => {
            if (item.departamento === this.selectedCultivo) {
              if (optionsFundoTemp.indexOf(item.area) < 0) {
                optionsFundoTemp.push(item.area);
                this.optionsFundo.push({ value: item.area, text: item.area });
              }
            }
          });
        }

        this.mostrarLugarFiltro();
      },
      mostrarLugarFiltro() {

        this.selectedLugar = 'TODOS';
        this.optionsLugar = [];

        const optionsLugarTemp = [];

        this.optionsLugar = [
          { value: 'TODOS', text: 'TODOS' }
        ]

        this.departamentos.filter((item) => {
          if (item.departamento === this.selectedCultivo && item.area === this.selectedFundo) {
            if (optionsLugarTemp.indexOf(item.seccion) < 0) {
              optionsLugarTemp.push(item.seccion);
              this.optionsLugar.push({ value: item.seccion, text: item.seccion });
            }
          }
        });

        if(this.optionsLugar.length === 0){
          if (this.key_empresa_sap === "PE10") { //AGROVISION
            this.optionsLugar = [
              //{ value: 'TODOS', text: 'TODOS' },
              { value: 'CAMPO', text: 'CAMPO' },
              { value: 'Packing Grande', text: 'Packing Grande' },
            ]

            if (this.selectedCultivo === "ARANDANO") {
              this.optionsLugar = [];
              this.optionsLugar = [
                //{ value: 'TODOS', text: 'TODOS' },
                { value: 'CAMPO', text: 'CAMPO' },
                { value: 'Packing Grande', text: 'Packing Grande' },
                { value: 'Packing A9', text: 'Packing A9' },
              ]
            }
            if (this.selectedCultivo === "ESPÁRRAGO") {
              this.optionsLugar = [];
              this.optionsLugar = [
                //{ value: 'TODOS', text: 'TODOS' },
                { value: 'CAMPO', text: 'CAMPO' },
                { value: 'Packing Esparrago', text: 'Packing Esparrago' },
              ]
            }
          }

          if (this.key_empresa_sap === "PE20") { //ARENA VERDE
            this.optionsLugar = [
              //{ value: 'TODOS', text: 'TODOS' },
              { value: 'CAMPO', text: 'CAMPO' },
            ]
          }
        }

        this.obtenerSanciones();
      },


    },
    created() {
      /*localStorage.setItem("userData", JSON.stringify({
          "id": 1,
          "fullName": "Renzo Carranza",
          "username": "renzo",
          "email": "renzo.carranza@agrovisioncorp.com",
          "dni": 45831349
      }));*/

      this.obtenerTipoSancion();
      this.obtenerDepartamentos();
      this.obtenerCategorias();
      this.obtenerSubCategorias();
      this.obtenerListMatriz();
      this.obtenerEstados();
      this.obtenerEmpresa();
      this.obtenerZonas();

      /*this.involucrados.push({ dni_involucrado: "12345678", nombre_involucrado: "nombre 1" });
      this.involucrados.push({ dni_involucrado: "22335548", nombre_involucrado: "nombre 2" });
      this.involucrados.push({ dni_involucrado: "87654444", nombre_involucrado: "nombre 3" });

      console.log(this.involucrados);*/
    },
  }
  </script>

  <style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  </style>
